module.exports = __webpack_public_path__ + "assets/img/73dc62f8b2f6ea686e2f6d8244ffdabc.png";